/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { GetProjectsProjectidSelectionsProjectselectionidOptions, GetProjectsProjectidSelectionsProjectselectionidResponses } from '../types/GetProjectsProjectidSelectionsProjectselectionid'
import { client, withUnwrap } from '../.kubb/client'

/**
 * {@link /projects/:projectId/selections/:projectSelectionId}
 */
export function getProjectsProjectidSelectionsProjectselectionid<ThrowOnError extends boolean = true>(options: Options<GetProjectsProjectidSelectionsProjectselectionidOptions, ThrowOnError>): Unwrappable<RequestResult<GetProjectsProjectidSelectionsProjectselectionidResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(request({ method: 'GET', url: '/projects/{projectId}/selections/{projectSelectionId}', security: [{ type: 'http', scheme: 'bearer' }], ...config, throwOnError: config.throwOnError ?? true }) as Promise<RequestResult<GetProjectsProjectidSelectionsProjectselectionidResponses, ThrowOnError>>)
}
